import { Button, InputText } from '@/components';
import React, { FormEvent } from 'react';
import { UseFormReturn } from 'src/hooks';
import logoFull from '../../../../assets/images/logo-full-white.png';

interface StateProps extends Pick<UseFormReturn, 'formData' | 'formErrors' | 'onChangeFormInput'> {
  state: boolean;
}

interface DispathProps {
  onSubmit: (e: FormEvent) => void;
}

export enum FormInputDocument {
  document = 'document',
}

type LoginContentProps = StateProps & DispathProps;

export const CallChangePasswordDocumentContent: React.FC<LoginContentProps> = ({
  state,
  formData,
  formErrors,
  onChangeFormInput,
  onSubmit,
}) => (
  <div>
    <div className="flex flex-col justify-center items-center">
      <img className="w-auto h-[120px]" src={logoFull} alt="Banca do Ingresso" />
    </div>

    <div className="mt-2 w-full">
      <form onSubmit={onSubmit}>
        <div className="mb-[15px]">
          <InputText
            name="document"
            label="CPF"
            placeholder="123.456.789-00"
            className={`appearance-none w-full
                rounded-md text-heading leading-tight focus:outline-none
                focus:shadow-outline text-xs font-dmsans font-normal`}
            maxLength={14}
            value={formData[FormInputDocument.document]}
            onChange={e => onChangeFormInput(FormInputDocument.document)(e.target.value)}
            error={formErrors.document && formErrors.document[0]}
          />
        </div>
        <div className="flex flex-col items-start justify-between">
          <Button
            type="submit"
            title="Entrar"
            buttonStyle="primary"
            size="xlg"
            className="w-full"
            disabled={formData[FormInputDocument.document] === '' || state}
          />
        </div>
      </form>
    </div>
  </div>
);
